import React, { useState, useEffect, forwardRef } from 'react';
import Grid from '@material-ui/core/Grid'
import MaterialTable from "material-table";
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import axios from 'axios'
import Alert from '@material-ui/lab/Alert';
import { useSelector, useDispatch } from "react-redux";

const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};

const api = axios.create({
    baseURL: 'MasterDetails'
})

const apiS = axios.create({
    baseURL: 'SlipGeneration'
})

function UnplannedIdleTime(props) {    
    const [data, setData] = useState([]); //table data
    const [unplannnedIdleTime, setunplannnedIdleTime] = useState([]);

    const token = useSelector((state) => state.saveAzureTokenReducer.token);
    const userDetails = useSelector(
    (state) => state.storeUserDetailsReducer.userData);
    const bearerToken = useSelector(
    (state) => state.saveBearerTokenReducer.bearerToken);
    const uId = useSelector((state) => state.saveUIDReducer.uid);

    //for error handling
    const [iserror, setIserror] = useState(false)
    const [errorMessages, setErrorMessages] = useState([])

    useEffect(() => {
        GetUnPlannedIdleTime();
        GetUnPlannedIdleTime_Trn();
    }, [])

    function GetUnPlannedIdleTime() {
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        api.get('/getTblMstUnPlannedIdleTime/',{
            headers: headers
        })
            .then(res => {
                //console.log("inside api master unPlannedIdleTime");
                //console.log(res.data);
                var obj = res.data.reduce(function (acc, cur, i) {
                    acc[cur.unPlannedIdleTimeId] = cur.unPlannedIdleTime;
                    return acc;
                }, {});
                //console.log(obj);
                setunplannnedIdleTime(obj);
            })
            .catch(error => {
                console.log("Error in hitting api at page load. unPlannedIdleTime")
            })
    }

    function GetUnPlannedIdleTime_Trn() {
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        //console.log(props.SlipGenId);
        apiS.get("/getTrnUnPlannedIdleTime/" + props.SlipGenId,{
            headers: headers
        })
            .then(res => {
                setData(res.data)
                //console.log("inside api transaction unPlannedIdleTime");
            })
            .catch(error => {
                console.log("Error")
            })
    }

    var columns = [
        { title: "", field: "unPlannedIdleTimeId", lookup: unplannnedIdleTime },
        { title: "", field: "unPlannedIdleTimeValue" },
        { title: "", field: "slipGenId", hidden: true },
        { title: "", field: "id", hidden: true },
]

    const handleRowUpdate = (newData, oldData, resolve) => {
        //validation
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        let errorList = []
        if (newData.unPlannedIdleTimeId === "") {
            errorList.push("Please enter unplanned idle time type");
        }
        if (newData.unPlannedIdleTimeValue === "" || newData.unPlannedIdleTimeValue == NaN || newData.unPlannedIdleTimeValue === undefined) {
            errorList.push("Please enter unplanned idle time value");
        }
        if (errorList.length < 1) {
            apiS.post("/SaveUnPlannedTime/", newData,{
                headers: headers
            })
                .then(res => {
                    const dataUpdate = [...data];
                    const index = oldData.tableData.id;
                    dataUpdate[index] = newData;
                    setData([...dataUpdate]);
                    setIserror(false)
                    setErrorMessages([])
                    props.getHeaderUnPlanCal(dataUpdate);
                    resolve()
               })
                .catch(error => {
                    setErrorMessages(["Update failed! Server error"])
                    setIserror(true)
                    resolve()
                })
        } else {
            setErrorMessages(errorList)
            setIserror(true)
            resolve()
        }
    }

    const handleRowAdd = (newData, resolve) => {
        //validation
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        let errorList = []
        if (newData.unPlannedIdleTimeId === "") {
            errorList.push("Please enter unplanned idle time type");
        }
        if (newData.unPlannedIdleTimeValue === "") {
            errorList.push("Please enter unplanned idle time value");
        }
        newData.id = 0;
        newData.slipGenID = props.SlipGenId;
        if (errorList.length < 1) { //no error
            apiS.post("/SaveUnPlannedTime/", newData,{
                headers: headers
            })
                .then(res => {
                    let dataToAdd = [...data];
                    newData.id = res.data;
                    dataToAdd.push(newData);
                    setData(dataToAdd);
                    setErrorMessages([])
                    setIserror(false)
                    props.getHeaderUnPlanCal(dataToAdd);
                    resolve()
                })
                .catch(error => {
                    setErrorMessages(["Cannot add data. Server error!"])
                    setIserror(true)
                    resolve()
                })
        } else {
            setErrorMessages(errorList)
            setIserror(true)
            resolve()
        }
    }

    const handleRowDelete = (oldData, resolve) => {
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        apiS.delete("/DeleteUnPlannedTime/" + oldData.id,{
            headers: headers
        })
            .then(res => {
                const dataDelete = [...data];
                const index = oldData.tableData.id;
                dataDelete.splice(index, 1);
                setData([...dataDelete]);
                props.getHeaderUnPlanCal(dataDelete);
                resolve();
            })
            .catch(error => {
                setErrorMessages(["Delete failed! Server error"])
                setIserror(true)
                resolve()
            })
    }

    return (
        <div className="width-100 mt-1">
            <Grid container spacing={1}>
                {
                    props.SlipGenId > 0 ?
                        (
                            <Grid item xs={12}>
                                <div>
                                    {iserror &&
                                        <Alert severity="error">
                                            {errorMessages.map((msg, i) => {
                                                return <div key={i}>{msg}</div>
                                            })}
                                        </Alert>
                                    }
                                </div>
                                <MaterialTable
                                    title="Unplanned Idle Time"
                                    columns={columns}
                                    data={data}
                                    icons={tableIcons}
                                    options={{
                                        search: false,
                                        paging: false,
                                    }}
                                    editable={{
                                        onRowUpdate: (newData, oldData) =>
                                            new Promise((resolve) => {
                                                handleRowUpdate(newData, oldData, resolve);
                                            }),
                                        onRowAdd: (newData) =>
                                            new Promise((resolve) => {
                                                handleRowAdd(newData, resolve)
                                            }),
                                        onRowDelete: (oldData) =>
                                            new Promise((resolve) => {
                                                handleRowDelete(oldData, resolve)
                                            }),
                                    }}
                                />
                            </Grid>
                        ) : <React.Fragment></React.Fragment>
                }
                
            </Grid>
        </div>
    );
}

export default UnplannedIdleTime;